// StoryCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import DiscoverShowMoreWrapper from '../component/DiscoverShowMoreWrapper.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'story-categories',
  categoryType: 'story',
  loaderName: 'StoryCategoriesCategory',
});

const StoryCategoriesCategoryRoute = () => {
  const { data, error } = useLoaderData();

  useSSRDataMerge({
    componentName: 'StoryCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return <DiscoverShowMoreWrapper />;
};

export default StoryCategoriesCategoryRoute;
